import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../services/apiService';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Container } from 'react-bootstrap';
import Header from './Header';

function ChangePassword() {
    const [passwordOld, setPasswordOld] = useState('');
    const [passwordNew, setPasswordNew] = useState('');
    const [passwordNewConfirm, setPasswordNewConfirm] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (passwordNew !== passwordNewConfirm) {
            console.error('Nové a potvrzující heslo se neshodují.');
            return;
        }

        try {
            const data = await apiFetch('/api/users/changePassword', {
                method: 'POST',
                body: JSON.stringify({ passwordOld, passwordNew, passwordNewConfirm }),
            });

            // Pokud API volání bylo úspěšné, přesměrujte uživatele
            navigate('/'); // Zde přesměrujte na požadovanou stránku
        } catch (error) {
            console.error('Chyba při pokusu o změnu hesla:', error);
        }
    };

    return (
        <div className=''>
            <Header headerAbsolute={false}/> 
            <Container className='col-md-4 container mt-5'>

                <h1 className='display-6 text-center'>Změna hesla</h1>

                <Form onSubmit={handleSubmit} className='mx-auto mt-5'>

                    <Form.Group className="mb-3" controlId="formPasswordOld">
                        <Form.Label>Současné heslo</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Heslo"
                            value={passwordOld}
                            onChange={(e) => setPasswordOld(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formPasswordNew">
                        <Form.Label>Nové heslo</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Heslo"
                            value={passwordNew}
                            onChange={(e) => setPasswordNew(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formPasswordNewConfirm">
                        <Form.Label>Potrvzení hesla</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Heslo"
                            value={passwordNewConfirm}
                            onChange={(e) => setPasswordNewConfirm(e.target.value)}
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" className='w-100 py-2 mt-2'>
                        Změnit heslo
                    </Button>
                </Form>
            </Container>

        </div>

    );
}

export default ChangePassword;